import { IconFileText } from "central-icons/IconFileText";
import IconGlobus from "central-icons/IconGlobus";

import { withGitpodSize } from "@/assets/icons/utils";
import type { PlainEnvironment } from "@/queries/environment-queries";

export const IconFileTextSized = withGitpodSize(IconFileText);
export const IconGlobusSized = withGitpodSize(IconGlobus);

/** MIME type used for tab drag-and-drop between split panes. */
export const TAB_DRAG_MIME = "application/x-tab-name";

// Stub used when environment data hasn't loaded yet. The hook safely handles
// undefined status (supportBundleUrl will be falsy, so environment.id is never accessed).
export const EMPTY_ENVIRONMENT = { id: "", status: undefined } as unknown as PlainEnvironment;
